import React from 'react';

interface AdminProp {
  server: string;
}

interface AdminState {
  posts: any[];
}

export class ITCGAdmin extends React.Component<AdminProp, AdminState> {
  state: AdminState;

  constructor(prop: AdminProp) {
    super(prop);
    this.state = {
      posts: [],
    };
  }
}
